import { ACCEPT_CONFIG } from "../artwork-file-types";

export default class FileProcessor {
  // Actions
  processFiles(files, onError) {
    if (!files?.length) return null;

    const supportedFiles = new Set();
    const unsupportedTypes = new Set();

    for (const file of files) {
      if (file.type in ACCEPT_CONFIG) {
        supportedFiles.add(file);
      } else {
        unsupportedTypes.add(file.type || "unknown");
      }
    }

    if (!supportedFiles.size && unsupportedTypes.size) {
      const supportedTypesList = Object.keys(ACCEPT_CONFIG).join(", ");
      this.reportError(
        onError,
        "unsupported_file_type",
        `Unsupported file type(s): ${[...unsupportedTypes].join(", ")}. Supported types: ${supportedTypesList}`
      );
      return null;
    }

    return Array.from(supportedFiles).map(file => {
      const url = URL.createObjectURL(file);
      return {
        file,
        url,
        revoke: () => URL.revokeObjectURL(url)
      };
    });
  }

  // Actions
  reportError(onError, code, messageOrError) {
    if (!onError) return;

    const error = this.constructor.createError(code, messageOrError);
    onError(error);
  }

  static createError(code, messageOrError) {
    return typeof messageOrError === "string"
      ? { code, message: messageOrError }
      : { code, error: messageOrError };
  }
}
